import { render, staticRenderFns } from "./FormLogin.vue?vue&type=template&id=48ae8280&scoped=true&"
import script from "./FormLogin.vue?vue&type=script&lang=js&"
export * from "./FormLogin.vue?vue&type=script&lang=js&"
import style0 from "./FormLogin.vue?vue&type=style&index=0&id=48ae8280&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ae8280",
  null
  
)

export default component.exports